export const TYPES_I18N = {
  monitoring: {
    time: $localize`:@@types.monitoring.time:時間`,
    swallowCount: $localize`:@@types.monitoring.swallowCount:えんげ回数`,
    coughCount: $localize`:@@types.monitoring.coughCount:咳の回数`,
  },
  fileTypes: {
    audio: $localize`:@@types.fileTypes.audio:音声(WAV)`,
    image: $localize`:@@types.fileTypes.image:画像`,
    movie: $localize`:@@types.fileTypes.movie:動画`,
    detail: $localize`:@@types.fileTypes.detail:付随データ(JSON)`,
  },
} as const;
